import React, {PropTypes, Component} from 'react';
import {Promise} from 'es6-promise';
import {connect} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import InputWithLabel from './InputWithLabel';
import {editComment, updateComment, createComment} from '../modules/Question-Comments';
import {emitEvent} from '../lib/mz';

require('es6-promise').polyfill();

function validateForm(values) {
  return Promise.resolve().then(() => {
    if (!values.comment) {
      throw new SubmissionError({
        comment: 'You must provide a comment ...',
      });
    }
  });
}

// eslint-disable-next-line react/prefer-stateless-function
class CommentForm extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    answer: PropTypes.object,
    comment: PropTypes.object,
    initialValues: PropTypes.object,
    error: PropTypes.string,
    reset: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    editComment: PropTypes.func.isRequired,
    onCloseCommentClick: PropTypes.func.isRequired,
  };

  render() {
    const {handleSubmit, submitting, onCloseCommentClick} = this.props;

    const isEditingComment = this.props.initialValues && this.props.initialValues.id;
    const acceptButtonText = isEditingComment ? 'Update comment' : 'Add comment';

    return (
      <form onSubmit={handleSubmit}>
        <Field name="comment" type="textarea" autoFocus rows="5" component={InputWithLabel} />
        <div className="action-buttons">
          <div className="action-buttons__item">
            <button className="tes-btn tes-btn--link tes-btn--sm tes-btn--no-gutter" onClick={onCloseCommentClick}>
              Cancel
            </button>
          </div>
          <div className="action-buttons__item action-buttons__item--align-right">
            <button type="submit" className="tes-btn tes-btn--primary tes-btn--sm" disabled={submitting}>
              {acceptButtonText}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

const editableFields = (comment) => (comment ? {
  id: comment.id,
  comment: comment.comment,
} : null);

const commentFormCreator = (formName) => {
  const ReduxCommentForm = reduxForm({
    form: formName || 'newComment',
  })(CommentForm);

  const ConnectedComment = connect((state, ownProps) => ({
    initialValues: editableFields(ownProps.comment),
  }), (dispatch, ownProps) => ({
    onSubmit: (values) =>
      validateForm(values).then(() => {
        const question = ownProps.question;
        const answer = ownProps.answer;
        const parentType = answer ? 'answer' : 'question';
        const extraValues = {answer_id: answer ? answer.id : null, question_id: question.id};
        const comment = Object.assign(values, extraValues);
        emitEvent('SUBMIT', {eventTitle: 'comment', module: {type: parentType}});
        return comment.id ? dispatch(updateComment(parentType, comment)) : dispatch(createComment({comment, question}));
      }),
    editComment: (comment, edit) => {
      dispatch(editComment(comment, edit));
    },
  }))(ReduxCommentForm);

  return ConnectedComment;
};

export default commentFormCreator;
